/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon20Light = forwardRef('ArrowADownLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.74 15.966c.084.022.17.034.26.034h8.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2V6.5a.5.5 0 0 1 1 0V15c0 .09.012.176.034.259L15.646 3.646a.5.5 0 0 1 .708.708L4.74 15.966Z" })));
});
